export const Logo = (props: any) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 93.8 93.8"
    width="2rem" // your milage may vary
    fill="currentColor"
  >
    <path d="M21.49,52.65c2.4,0,7.1.8,6.6,3.3l-.6,3.1H23l.2-1.2c.2-.9-1.2-1-1.8-1-3.5,0-5,3.3-5,5.5,0,1.9.9,3.6,3.3,3.6,1.1,0,1.9-.2,2-.9l.2-1.2h4.5l-.5,2.8c-.6,2.9-4.3,3.6-6.7,3.6-4.8,0-8.2-3.1-8.2-7.6a10.47,10.47,0,0,1,10.5-10"></path>
    <polygon points="35.69 52.15 39.99 52.15 30.29 71.05 25.89 71.05 35.69 52.15"></polygon>
    <path d="M42.69,63.55l-.2,1.1c-.2,1,1.1,1.2,2.1,1.2,1.4,0,1.9-.7,1.9-1.3,0-1.5-7.1-1.1-7.1-6.3,0-4.1,3.6-5.6,7.4-5.6,2.1,0,6.3.6,5.7,3.8l-.5,2.4h-4.5l.2-1.1c.1-.6-.6-.8-1.4-.8-1.3,0-1.7.5-1.7,1,0,2,7.1,1.1,7.1,6.4,0,4-3.6,5.9-7.7,5.9-2.5,0-6.8-1.2-6.2-4.8l.4-2h4.5Z"></path>
    <path d="M5.6,61.6H0V93.8H34.8V88.2H5.6ZM40.8,0,5.6,35.1H58.7V88.2L93.8,53.4V0Z"></path>
  </svg>
);
